import { ComponentType } from './cpm-def-ext.model';

export function getComponentProp<T, K extends keyof T>(t: ComponentType<T>, key: string): T[K] {
  if (t.hasOwnProperty(key)) {
    return t[key as keyof ComponentType<T>];
  }

  throw new Error('No Angular property found for ' + t.name);
}
